<template>
  <div class="main">
    <loading color="#1989fa" vertical>正在登录...</loading>
  </div>
</template>
<script>
// import { getUserId } from '@/api/service'
import {IS_DEBUG} from '/env'
import {Dialog, Loading} from 'vant';
import {authByCode, loginByUserid} from '@/api/login'
import Cookies from "js-cookie";

export default {
  name: 'Home',
  components: {
    Loading
  },
  data() {
    return {
      userId: '', // 用户id
    }
  },
  created() {

  },
  mounted: function () {
    if (IS_DEBUG) {
      this.testLogin()
      return
    }
    // sessionStorage.setItem("token",'eyJ0eXAiOiJKV1QiLCJhbGciOiJIUzI1NiJ9.eyJzdWIiOiJidWJibGUiLCJyb2xlIjoiWzEsNSw0XSIsImlzcyI6InJlblJ1aSIsIm5hbWUiOiLnjovno4rlvLoiLCJkZXB0SWQiOjk1NSwiZXhwIjoxNjkyNDI1MzUyLCJ1c2VySWQiOiJXYW5nbGVpcWlhbmcifQ.gYwgaKV9XawK1RYCs9qyUD2--E8W0T9Lt6IsOGGBOhM');
    var token = sessionStorage.getItem("token");
    if (undefined == token) {
      if (this.$route.query.code == undefined) {
        // 获取code的url拼接
        let nowUrl = window.location.href;
        let backurl = encodeURIComponent(nowUrl)
        const url = 'https://open.weixin.qq.com/connect/oauth2/authorize?appid=wwf93ebffd5d31aa7a&redirect_uri=' + encodeURIComponent(backurl) + '&response_type=code&scope=snsapi_base&state=STATE#wechat_redirect'
        console.log(url)
        window.location.href = url
      } else {
        // 得到授权code
        var code = this.$route.query.code
        this.authOnCode(code)
        console.log(code)
      }
    }
  },
  methods: {
    testLogin() {
      const query = this.$route.query
      console.log('query', query)
      let userid = query.userId ? query.userId : 'MaHui'
      loginByUserid({userId: userid}).then((res) => {
        console.log(res);
        sessionStorage.setItem("userId", userid);
        sessionStorage.setItem("token", res.data.token);
        sessionStorage.setItem("username", res.data.userName);
        Cookies.set('userId', userid)
        let path = sessionStorage.getItem("redirect");
        let query = sessionStorage.getItem("search");
        if (query != undefined) {

          this.$router.push({path: path, query: JSON.parse(query)})
        } else {
          this.$router.push({path: path})
        }
      })
    },
    objectToString(object) {
      let text = ''
      for (let key in object) {
        text += key + '=' + object[key] + '&'
      }
      text = text.substring(0, text.length - 1);
      return text;
    },
    authOnCode(code) {
      authByCode({code: code}).then((res) => {
        let userid = res.data;
        console.log(userid);

        loginByUserid({userId: userid}).then((res) => {
          console.log(res);
          sessionStorage.setItem("userId", userid);
          sessionStorage.setItem("token", res.data.token);
          sessionStorage.setItem("username", res.data.userName);
          Cookies.set('userId', userid)
          // 得到用户校色
          let roleIds = JSON.parse(res.data.roleId);
          // 调转页面
          let path = sessionStorage.getItem("redirect");
          let query = sessionStorage.getItem("search");
          // 默认跳转到采购列表
          if (!path) {
            window.location.replace(location.origin + '/demand')
            return
          }
          if (query != undefined) {
            const targetUrl = location.origin + '/' + path + '?' + this.objectToString(JSON.parse(query))
            window.location.replace(targetUrl)
          } else {
            window.location.replace(location.origin + '/demand')
          }
        })
      })
    }
  }
}
</script>

<style scoped>
.main {
  background-color: #ffffff;
  padding: 20px;
  min-height: 100vh;
}
</style>
